import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { AiIntegrationBedrockProviderConfig } from "../providerConfig";
import { SEARCH_BEDROCK_INFERENCE_PROFILES } from "./gql";

type UseAiIntegrationBedrockInferenceProfilesProps = {
  awsIntegrationId?: string;
  providerConfig?: AiIntegrationBedrockProviderConfig;
};

const useAiIntegrationBedrockInferenceProfiles = ({
  awsIntegrationId,
  providerConfig,
}: UseAiIntegrationBedrockInferenceProfilesProps) => {
  const shouldSkip = !awsIntegrationId || !providerConfig;
  const { data, previousData, error, loading } = useQuery(SEARCH_BEDROCK_INFERENCE_PROFILES, {
    variables: shouldSkip
      ? undefined
      : {
          awsIntegration: awsIntegrationId,
          config: providerConfig,
        },
    skip: shouldSkip,
  });

  const profiles = useMemo(() => {
    return data?.bedrockInferenceProfiles || previousData?.bedrockInferenceProfiles || [];
  }, [data, previousData]);

  return {
    profiles,
    error,
    loading,
  };
};

export default useAiIntegrationBedrockInferenceProfiles;
